// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"227c0e78","455":"69fbafce"}[chunkId] + ".chunk.js";
};